import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbCollapseModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CdkMenuModule } from '@angular/cdk/menu';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NoAuthenticatedLayoutComponent } from './layouts/no-authenticated-layout/no-authenticated-layout.component';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { SharedModule } from './modules/shared.module';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { SnackBarComponent } from './components/snackbar/snackbar.component';
import { AuthenticatedLayoutModule } from './layouts/authenticated-layout/authenticated-layout.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { UserProfileModule } from './components/user/user-profile.module';
import { ContractsModule } from './components/contracts/contracts.module';
import { LanguageService } from './services/language.service';
import { ContractsViewModule } from './components/contracts/contracts-view/contracts-view.module';
import { SpinnerService, IS_APP_ID, AppId, ENVIRONMENT } from 'is-lib';
import { DateRangePipe } from 'is-lib';
import { environment } from 'src/environments/environment';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http,  [
    {prefix: './assets/i18n/', suffix: '.json'},
    {prefix: './assets/is-lib/i18n/', suffix: '.json'}
  ]);
}

const isLibEnvironment = {
  ...environment,
  apiUrl: environment.apiUrl.replace(/\/+$/, '')
};

registerLocaleData(localePt, 'pt-PT');

@NgModule({
  declarations: [
    AppComponent,
    NoAuthenticatedLayoutComponent,
    SnackBarComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    CdkMenuModule,
    CdkAccordionModule,
    MatSnackBarModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpBackend]
      }
    }),
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    NgbCollapseModule, 
    MatTooltipModule,
    MatProgressBarModule,
    MatExpansionModule,
    ClipboardModule,
    SharedModule,
    AuthenticatedLayoutModule,
    UserProfileModule,
    ContractsModule,
    ContractsViewModule,
  ],
  providers: [
    CookieService, 
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    // { provide: LOCALE_ID, deps: [LanguageService], useFactory: (LanguageService: { locale: string; }) => LanguageService.locale},
    {provide: LOCALE_ID, useValue: 'pt-PT'},
    { provide: ErrorHandler},
    SpinnerService,
    { provide: ENVIRONMENT, useValue: isLibEnvironment },
    { provide: IS_APP_ID, useValue: AppId.CLIENT },
    {
      provide: 'MV_SPINNER_TEMPLATE',
      useValue: "<img src='assets/images/logos/mv_logo_100-100.gif'/>"
    }
  ],
  bootstrap: [AppComponent],
})

//Only way it was working!! initializes the language service before
export class AppModule {
  constructor(private _languageService: LanguageService) {
    // Force initialization of LanguageService so translations are ready for public routes
  }
}
